module.exports={turnstile_modal:{message:"A verificar detalhes de segurança"}};